// extracted by css-extract-rspack-plugin
export default {"drawerModeBreakpoint":"1040px","longCardBreakpoint":"580px"};